import { injectable } from "inversify";
import QARepository from "../../../domain/repositories/qa.repository";
import { Either, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/error.entity";
import QAAgentEntity from "../../../domain/entities/qa_agent.entity";
import QAQuestionEntity from "../../../domain/entities/qa_question.entity";
import QARepositoryFake from "./qa.repository.fake";
import SearchResultEntity from "../../../domain/entities/search_result.entity";
import searchAgentsApiImpl from "./api/search_agents.api.impl";
import getAgentByIdApiImpl from "./api/get_agent_by_id.api.impl";
import updateQuestionApiImpl from "./api/update_question.api.impl";
import createAgentApiImpl from "./api/create_agent.api.impl";
import deleteQuestionApiImpl from "./api/delete_question.api.impl";
import deleteAgentApiImpl from "./api/delete_agent.api.impl";
import QACategoryEntity from "../../../domain/entities/qa_category.entity";
import updateAgentApiImpl from "./api/update_agent.api.impl";
import createQuestionApiImpl from "./api/create_question.api.impl";
import createCategoryApiImpl from "./api/create_qa_category.api.impl";
import deleteCategoryApiImpl from "./api/delete_category.api.impl";
import updateCategoryApiImpl from "./api/update_qa_category.api.impl";
import MasterItemEntity from "../../../domain/entities/master_item.entity";
import searchOpTypesApiImpl from "./api/search_op_types.api.impl";

@injectable()
class QARepositoryDev implements QARepository {
  fakeRepository = new QARepositoryFake();

  searchOpTypes = (_: { query: string | undefined; page: number; itemsPerPage: number; }): Promise<Either<ErrorEntity, SearchResultEntity<MasterItemEntity>>> => searchOpTypesApiImpl(_);
  //category
  addCategory = (qaCategory: QACategoryEntity): Promise<Either<ErrorEntity, QACategoryEntity>> => createCategoryApiImpl(qaCategory);
  updateCategory = (qaCategory: QACategoryEntity): Promise<Either<ErrorEntity, QACategoryEntity>> => updateCategoryApiImpl(qaCategory);
  deleteCategory = (id: string): Promise<Either<ErrorEntity, void>> => deleteCategoryApiImpl(id);
  //agent
  createAgent = async (formData: FormData): Promise<Either<ErrorEntity, QAAgentEntity>> => {
    const name = formData.get("name")?.toString() ?? "Dev name";
    const description = formData.get("description")?.toString() ?? "Dev description";
    const target = formData.get("target") ? Number(formData.get("target")) : undefined;

    return right(new QAAgentEntity({
      id: "dev-id",
      name,
      description,
      target,
      flexibility: 100,
      clientId: "dev-client",
      categories: [],
      files: [],
      assistant_id: "fake-assistant",
      vector_store_id: "fake-vector",
      is_assistant: true,
    }));
  };


  searchAgents = (_: { query: string, page: number, itemsPerPage: number }): Promise<Either<ErrorEntity, SearchResultEntity<QAAgentEntity>>> => searchAgentsApiImpl(_);
  getAgentById = async (id: string): Promise<Either<ErrorEntity, QAAgentEntity>> => getAgentByIdApiImpl(id);
  deleteAgent = (id: string): Promise<Either<ErrorEntity, void>> => deleteAgentApiImpl(id);
  updateAgent = async (formData: FormData): Promise<Either<ErrorEntity, QAAgentEntity>> => {
    const id = formData.get("id")?.toString() ?? "temp-id";
    const name = formData.get("name")?.toString() ?? "Sin nombre";
    const description = formData.get("description")?.toString() ?? "";
    const target = Number(formData.get("target")) || 0;
    const flexibility = Number(formData.get("flexibility")) || 0.5;
    files: formData.getAll("files").map((f: any, i) => ({
      file_id: `fake-file-id-${i}`,
      filename: f.name ?? `file-${i}`,
      vector_store_id: "fake-vector-id"
    }));
    
    return right(new QAAgentEntity({
      id,
      name,
      description,
      target,
      flexibility,
      clientId: "dev-client",
      opTypeId: "dev-optype",
      categories: [],
      files: [],
      assistant_id: "fake-assistant",
      vector_store_id: "fake-vector",
      is_assistant: true,
    }));
  };
  //questions
  addQuestionToAgent = async (_: { category: QACategoryEntity, question: QAQuestionEntity }): Promise<Either<ErrorEntity, QAQuestionEntity>> => createQuestionApiImpl(_);
  deleteQuestionFromAgent = async (questionId: string): Promise<Either<ErrorEntity, void>> => deleteQuestionApiImpl(questionId);
  updateQuestionFromAgent = (question: QAQuestionEntity): Promise<Either<ErrorEntity, QAQuestionEntity>> => updateQuestionApiImpl(question);
}

export default QARepositoryDev;